<app-auth-shell [testimonial]="false">
  <!-- until the flag is known, it's still maintenance -->
  @if (maintenanceEnabled() === false) {
    <app-auth-header
      [title]="'pages.auth.maintenance.over.title' | transloco"
      [subtitle]="'pages.auth.maintenance.over.subtitle' | transloco" />
    <vx-button
      class="mt-8"
      size="lg"
      [fullWidth]="true"
      (click)="returnToDashboard()">
      {{ 'pages.auth.maintenance.over.openDashboard' | transloco }}
    </vx-button>
  } @else {
    <app-auth-header
      [title]="'pages.auth.maintenance.title' | transloco"
      [subtitle]="'pages.auth.maintenance.subtitle' | transloco" />
  }
  <app-auth-help />
</app-auth-shell>
